import { styled, Typography, TypographyProps } from '@mui/material';

export const NoMoreCommentsMessage = styled((props: TypographyProps) => (
  <Typography variant="paragraphRegular" {...props} />
))(({ theme }) => ({
  color: theme.palette.grey[400],
  textAlign: 'center',
}));
